import { StrictMode, createContext, useContext } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../js/api/queryClient";
import { RecentActivityFeedWrapper } from "./components/activity-feed/recent-activity-feed-wrapper";

const RecentActivityFeedContext = createContext();
export const useRecentActivityFeed = () =>
  useContext(RecentActivityFeedContext);
function RecentActivityFeedProvider({ data, children }) {
  return (
    <RecentActivityFeedContext.Provider value={data}>
      {children}
    </RecentActivityFeedContext.Provider>
  );
}

function RecentActivityFeedRenderer() {
  const elements = document.querySelectorAll(".react-recent-activity-feed");
  if (!elements) return;
  elements.forEach((element) => {
    let initialProps = {};
    try {
      initialProps = JSON.parse(element.getAttribute("data-initial-props"));
    } catch (error) {
      console.error(
        error,
        "Could not parse initial props JSON for RecentActivityFeed"
      );
    }

    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <RecentActivityFeedProvider data={initialProps}>
            <RecentActivityFeedWrapper />
          </RecentActivityFeedProvider>
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initRecentActivityFeed = () => {
  if (document.readyState !== "loading") {
    RecentActivityFeedRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", RecentActivityFeedRenderer);
  }
};
